import * as angular from "angular";
import {$bringozFactory} from "../persistence-layer/bringoz-factory.factory";
import {BringozApi} from "../persistence-layer/models/bringoz-api.model";
import {DataStoreConfig} from "../persistence-layer/models/datastore-config.model";

angular
  .module('bringoz.admin.deliveries')
  .factory('$recurringServices', RecurringServicesObjectFactory);

/* @ngInject */
function RecurringServicesObjectFactory($bringozFactory: $bringozFactory,
                                        RecurringServicesAPI: BringozApi,
                                        RecurringServices_DS: DataStoreConfig) {

  function $recurringServices(id: string) {
    return $bringozFactory(id, RecurringServicesAPI, RecurringServices_DS);
  }

  return $recurringServices;
}
